import { DBBranchesByCompanyID, UserWithCompaniesIDs } from "@/types";
import { createContext } from "react";

export type MergeCompaniesContextType = {
  allCompanies: DBBranchesByCompanyID[];
  allUsers: UserWithCompaniesIDs[];
  keepSideUser: UserWithCompaniesIDs | null;
  removeSideUser: UserWithCompaniesIDs | null;
  keepSideCompany: DBBranchesByCompanyID | null;
  removeSideCompany: DBBranchesByCompanyID | null;
  setKeepSideCompany: (company: DBBranchesByCompanyID | null) => void;
  setRemoveSideCompany: (company: DBBranchesByCompanyID | null) => void;
  mergedCompany: DBBranchesByCompanyID | null;
  successfulSubmission: boolean;
  setSuccessfulSubmission: (success: boolean) => void;
  resetStates: () => void;
};

export const defaultMergeCompaniesContext: MergeCompaniesContextType = {
  allCompanies: [],
  allUsers: [],
  keepSideUser: null,
  removeSideUser: null,
  keepSideCompany: null,
  removeSideCompany: null,
  setKeepSideCompany: () => {},
  setRemoveSideCompany: () => {},
  mergedCompany: null,
  setSuccessfulSubmission: () => {},
  successfulSubmission: false,
  resetStates: () => {},
};

export const MergeCompaniesContext = createContext<MergeCompaniesContextType>(
  defaultMergeCompaniesContext
);
